(function() {
    document.querySelectorAll('.tab-link').forEach((item)=>{
        item.addEventListener('click', et=>{
            let sectionidd = et.currentTarget.dataset.section;
            let dataurl = et.currentTarget.dataset.url;

            if( sectionidd && dataurl ){
                document.getElementById(sectionidd).querySelector('.btnholder a').href = dataurl;
            }
        })
    })

})();